import React, { useState } from "react";
import axios from "axios";
import { Changepassurl } from "./../Utils/urls";
import { Link, useNavigate } from "react-router-dom";
import { getsessionuser } from './../Utils/sessions';
import { Modal } from "@mui/material";
import SignIn from "../Common/login";



let color = "white";
let type = "spokes";


const Security = () => {

    const navigate = useNavigate();


    const sessionuser = getsessionuser();
    const [user, setuser] = useState(sessionuser);
    const [showlogin, setshowlogin] = useState(false);


    const [opassword, setopassword] = useState('');
    const [npassword, setnpassword] = useState('');
    const [cpassword, setcpassword] = useState('');

    const [profileimage, setprofileimage] = useState('');

    const [progress, setprogress] = useState(false);
    const [loading, setloading] = useState(false);
    const [error, seterror] = useState('');
    const [error2, seterror2] = useState('');
    const [successdiv, setsuccessdiv] = useState(false);




    //save user password
    const savepassword = () => {
        setprogress(true)
        seterror(null)
        if (!npassword || !opassword || !cpassword) {
            seterror("fill all fields")
            setprogress(false)
        } else if (npassword !== cpassword) {
            seterror("The new passwords do not match")
            setprogress(false)
        }
        else {
            seterror(null)
            axios.post(Changepassurl, {
                email: user.email,
                password: cpassword,
                currentpassword: opassword
            }).then(response => {
                setprogress(false)
                if (!response.data.message) {
                    setsuccessdiv(true)
                    setTimeout(() => {
                        setsuccessdiv(false)
                    }, 3000);
                } else {
                    seterror(response.data.message)
                }
                // 
            }).catch(error => {
                setprogress(false)
                seterror("Sorry an error occurred,try again later");


            });
        }
    }



    const onsuccesslogin = () => {
        setshowlogin(false)
    }


    return (
        <div >
            <div style={{ paddingBottom: 100 }}>
                <br />
                <Modal
                    open={showlogin}
                    onClose={() => setshowlogin(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <SignIn onsuccesslogin={onsuccesslogin} />
                </Modal>


            </div>
        </div>
    )
}

export default Security;